export default __webpack_public_path__ + "static/media/NOK.876ff707.svg";